// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const HEARTS_LINK_LABEL = "Srdie\u010dka";
export const MESSAGES_LINK_LABEL = "Spr\u00e1vy";
export const NOTIFICATIONS = "Upozornenia";
